import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IRefundRule } from "../contracts";

export function useRefundRule(id: number) {
  const { request } = usePbm2Url();
  return useQuery(`refundRule:${id}`, async () => {
    const { Refund_refundRule } = await request(
      gql`
        query ($id: ID!) {
          Refund_refundRule(id: $id) {
            rulesId
            startDate
            endDate
            createdAt
            updatedAt
            product {
              id
              name
              description
            }
            ranges {
              rangeId
              discount
              discountRefund
            }
            configuration {
              headquarters {
                id
                name
              }
              states {
                stateId
                name
              }
            }
          }
        }
      `,
      { id }
    );
    return Refund_refundRule as IRefundRule;
  });
}
